import React from 'react';
import styles from './CoreParagraph.module.scss';
import className from 'classnames/bind';
import { gql } from '@apollo/client';
import formatStyles from '@/helpers/formatStyles';
import { RichText } from '@/components';

let cx = className.bind(styles);

export default function CoreParagraph(props) {
	const { attributes } = props;
	const styles = formatStyles(attributes.style);
  const className = attributes.className?.split(' ') || [];

	return (
		attributes.content && (
      <RichText elem='p' id={attributes.anchor} className={cx(['paragraph', ...className, attributes.align && `textAlign-${attributes.align}`, attributes.fontSize && `is-font-size-${attributes.fontSize}`, attributes.backgroundColor && `bg-${attributes.backgroundColor}`, attributes.textColor && `text-color-${attributes.textColor}`])} style={styles} html={attributes.content} />
		)
	);
}

CoreParagraph.fragments = {
	key: `CoreParagraphFragment`,
	entry: gql`
		fragment CoreParagraphFragment on CoreParagraph {
			attributes {
				align
				anchor
				className
				content
        fontSize
				style
        textColor
        backgroundColor
			}
		}
	`,
};


CoreParagraph.config = {
	name: 'CoreParagraph',
};
CoreParagraph.displayName = 'CoreParagraph';